import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetMediaQuery } from '../../data/queries/get-media.query'
import { GetMediaTotalsQuery } from '../../data/queries/get-media-totals.query'
import {
  type MediaPageEntity,
  type MediaTotalsEntity,
  type SortByEntity,
  type SortOrderEntity
} from '../../data/entities/media.entity'
import { CombinedMediaToSongsResponseMapper } from '../mappers/songs.mappers'
import { type SongsResponse } from '../models/songs'

export interface GetSongsParams {
  fromDate: string
  toDate: string
  fromPrevious: string
  toPrevious: string
  sortBy: SortByEntity
  sortOrder: SortOrderEntity
  page: number
  pageSize: number
  organization: string
}

export class GetSongsInteractor {
  private readonly mapper = new CombinedMediaToSongsResponseMapper()

  constructor(
    private readonly getMedia: GetInteractor<MediaPageEntity>,
    private readonly getMediaTotals: GetInteractor<MediaTotalsEntity>
  ) {}

  public async execute(params: GetSongsParams): Promise<SongsResponse> {
    const offset = (params.page - 1) * params.pageSize

    const [pageResult, totalsResult] = await Promise.all([
      this.getMedia.execute(
        new GetMediaQuery(
          params.fromDate,
          params.toDate,
          params.fromPrevious,
          params.toPrevious,
          params.sortBy,
          params.sortOrder,
          offset,
          params.pageSize,
          'song',
          params.organization
        )
      ),
      this.getMediaTotals.execute(
        new GetMediaTotalsQuery(
          params.fromDate,
          params.toDate,
          params.fromPrevious,
          params.toPrevious,
          'song',
          params.organization
        )
      )
    ])

    return this.mapper.map({ page: pageResult, totals: totalsResult })
  }
}
